import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const CareerClusterSurveyCategoriesQuery = async (category_id=null) => (
  await Query(`
    {
      career_cluster_survey_categories(${jsonToInputParams({category_id: category_id})}) {
        id
        title
        description
        questions {
          question
          id
        }
      }
    }
  `)
);

export default CareerClusterSurveyCategoriesQuery;
